import Link from 'next/link';

export default function ProductLink(
    {
        product,
        className,
        children,
        style,
    },
) {
    const url = `/${product?.seoUrls?.[0]?.seoPathInfo}` || `/details/${product?.id}`;

    return <Link href={url}>
        <a style={style}
           className={className}
        >
            {children}
        </a>
    </Link>;
}
